import { render } from "./RatesManagement.vue?vue&type=template&id=670ab31f&ts=true"
import script from "./RatesManagement.vue?vue&type=script&lang=ts"
export * from "./RatesManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__